import { Box, Button } from '@mui/material'
import images from 'assets/images'
import linkedin from 'helpers/integrations/linkedin'
import { useLocation } from 'react-router-dom'
import { URL_APP } from 'helpers/config'
import { RequesterType } from 'helpers/types'

type Props = {
  textButton: string
  id?: string
}

const LoginWithLinkedInButton = (props: Props) => {
  const location = useLocation()

  const searchParams = new URLSearchParams(location.search)

  const onClick = () => {
    linkedin.connect({
      redirectUrl: searchParams.get('redirectUrl') || URL_APP,
      requester: searchParams.get('requester') as RequesterType,
      action: 'LOGIN',
    })
  }

  return (
    <Button
      onClick={onClick}
      id={props.id}
      variant="outlined"
      color="primary"
      sx={{
        width: '100%',
        textTransform: 'none',
        '&, &:hover': { borderColor: '#1445FE' },
      }}
    >
      <Box display="flex" justifyContent="center" alignItems="center" gap="8px">
        <img alt="linkedin logo" style={{ height: '20px' }} src={images.LINKEDIN_BUTTON_LOGO} />
        <span className="link">{props.textButton}</span>
      </Box>
    </Button>
  )
}

export default LoginWithLinkedInButton
